/*************************************************/
/* ACCORDION                                     */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function accordion() {
    let resizeTimer;
    const accordionComponentSelector = '.accordion-component';
    const accordionParentSelector = '.accordion';
    const accordionItemSelector = '.accordion__item';
    const accordionItemToggleSelector = '.accordion__item-head';
    const accordionItemContentSelector = '.accordion__item-content';
    const accordionItemActiveClass = 'accordion__item--active';
    const accordionIdDataAttributeName = 'data-accordion-id';
    const accordionItemIdDataAttributeName = 'data-accordion-item-id';
    const accordionImagesSelector = '.image-accordion';
    const accordionImagesContainerSelector = '.image-accordion__media-container';
    const accordionTabControlSelector = '.accordion-component__tab';

    const getTargetedAccordion = (event) => {
        if (event != null) {
            return document.querySelector(
                `[${accordionIdDataAttributeName}="${event.detail.accordionId}"]`);
        }
    };
    const getTargetedAccordionItem = (event) => {
        if (event != null) {
            const targetedAccordion = getTargetedAccordion(event);
            if (targetedAccordion != null) {
                return targetedAccordion.querySelector(
                    `[${accordionItemIdDataAttributeName}="${event.detail.accordionItemId}"]`
                );
            }
        };
    }

    const activateAccordion = (tab, accordion) => {
        if (accordion) {
            //Deactivate others
            const accordionComponent = accordion.closest(accordionComponentSelector);

            const accordionSiblings = accordionComponent.querySelectorAll(accordionParentSelector);
            accordionSiblings.forEach(sibling => {
                sibling.setAttribute('hidden', 'hidden');
            });

            const tabSiblings = accordionComponent.querySelectorAll(accordionTabControlSelector);
            tabSiblings.forEach(sibling => {
                sibling.setAttribute('aria-selected', 'false');
            })

            //Active new one
            accordion.removeAttribute('hidden');
            tab.setAttribute('aria-selected', 'true');
            setActiveStylesOnAccordionItem(accordion.querySelector(accordionItemSelector));
        }
    }

    const setActiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = `${accordionItemContent.scrollHeight}px`;
            accordionItemContent.setAttribute('aria-hidden', false);
            accordionItem.classList.add(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', true);
        }
    };

    const setInactiveStylesOnAccordionItem = (accordionItem) => {
        if (accordionItem != null) {
            const accordionItemContent = accordionItem.querySelector(accordionItemContentSelector);
            accordionItemContent.style.maxHeight = "0px";
            accordionItemContent.setAttribute('aria-hidden', true);
            accordionItem.classList.remove(accordionItemActiveClass);
            accordionItem.setAttribute('aria-expanded', false);
        }
    };

    const init = () => {
        const accordions = document.querySelectorAll(accordionParentSelector);
        const accordionTabs = document.querySelectorAll(accordionTabControlSelector);
        if (accordion != null && accordions.length > 0) {
            // Reset maxHeight's on active items if screen width changes
            window.addEventListener('resize', e => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    const activeAccordionItems = document.querySelectorAll('.' + accordionItemActiveClass);
                    if (activeAccordionItems) {
                        activeAccordionItems.forEach(accordionItem => {
                            const content = document.querySelector('#' + accordionItem.dataset.accordionItemContentId);
                            content.style.maxHeight = `${content.scrollHeight}px`;
                        });
                    }
                }, 50);
            });

            accordions.forEach(accordion => {
                accordion.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem) {
                        const deactivateAllItemsEvent = new CustomEvent(customEventsNames.accordionDeactivateAllItemsEventName, {
                            detail: {
                                accordionId: e.detail.accordionId
                            }
                        });
                        accordion.dispatchEvent(deactivateAllItemsEvent);
                    }

                    if (targetedAccordionItem != null) {
                        setActiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateItemEventName, e => {
                    const targetedAccordionItem = getTargetedAccordionItem(e);
                    if (targetedAccordionItem != null) {
                        setInactiveStylesOnAccordionItem(targetedAccordionItem);
                    }
                });

                accordion.addEventListener(customEventsNames.accordionDeactivateAllItemsEventName, e => {
                    const targetedAccordion = getTargetedAccordion(e);
                    if (targetedAccordion != null) {
                        targetedAccordion.querySelectorAll(accordionItemSelector).forEach(accordionItem => {
                            setInactiveStylesOnAccordionItem(accordionItem);
                        });
                    }
                });

                accordion.querySelectorAll(accordionItemToggleSelector).forEach(accordionItem => {
                    accordionItem.addEventListener('click', e => {
                        const clickedAccordionItem = e.target.closest(accordionItemSelector);
                        const itemId = clickedAccordionItem.dataset.accordionItemId;
                        const itemIndex = clickedAccordionItem.dataset.accordionItemIndex;
                        const accordionParent = e.target.closest(accordionParentSelector);
                        const accordionId = accordionParent.dataset.accordionId;

                        if (clickedAccordionItem.classList.contains(accordionItemActiveClass)) {
                            const deactiveAccordionItemEvent = new CustomEvent(customEventsNames.accordionDeactivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                }
                            });
                            accordionParent.dispatchEvent(deactiveAccordionItemEvent);
                        } else {
                            const activateAccordionItemEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: itemId,
                                    accordionItemIndex: itemIndex,
                                }
                            });
                            accordionParent.dispatchEvent(activateAccordionItemEvent);

                            const accordionImagesParent = accordionItem.closest(accordionImagesSelector);
                            if (accordionImagesParent) {
                                accordionImagesParent.querySelector(accordionImagesContainerSelector).dispatchEvent(activateAccordionItemEvent)
                            }
                        }
                    });
                });
                window.requestAnimationFrame(() => {
                    setActiveStylesOnAccordionItem(accordion.querySelector(`.${accordionItemActiveClass}`));
                });

                const accordionInitialized = new CustomEvent(customEventsNames.accordionInitialised, {});
                accordion.dispatchEvent(accordionInitialized);
            });
            if (accordionTabs && accordionTabs.length > 0) {

                accordionTabs.forEach(tab => {
                    tab.addEventListener('click', e => {
                        const accordion = document.getElementById(tab.getAttribute('aria-controls'));
                        if (accordion) {
                            activateAccordion(tab, accordion);
                        }
                    });
                });
            }
        }
    };

    init();
}

export function accordionImages() {

    const accordionImagesContainerSelector = ".image-accordion__media-container";
    const accordionImageSelector = ".image-accordion__media";
    const accordionImageActiveClass = "image-accordion__media--active";
    const accordionImageFallbackClass = "image-accordion__media--fallback";
    const defaultItemIndex = 1; // The index of the default item

    const init = () => {
        const imageContainers = document.querySelectorAll(accordionImagesContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {

                // Select both the default and fallback images
                const images = container.querySelectorAll(accordionImageSelector);

                if (images[defaultItemIndex].classList.contains(accordionImageActiveClass)) {
                    images[0].classList.remove(accordionImageActiveClass);
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(accordionImageSelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}